$(".custom-options .variant-option").each(function() {
    $(this).on("click", function() {
      // Get the selected variant's title and price
      var selectedVariantId = parseInt($(this).attr("data-var-id"));
    var jsonLdData = $('script[data-custom-variants]').html();
      var productVariantForm = $('form .product-variant-id')
  
  // Parse the JSON-LD data into a JavaScript object
  var productData = JSON.parse(jsonLdData);
 const currentVariant = productData.filter(function(variant) {
    return variant.id == selectedVariantId;
  })[0]
  
      const {id,title} = currentVariant
      const currentVariantDom =  $(".current-selected-varaint .variant-title")
     currentVariantDom.text(title);
      productVariantForm.val(id)
      $('.current-selected-varaint ').attr('data-cur-id',id)
      $('.custom-select').removeClass('active')
    
    });

})
     $(".custom-select-button ").on("click", function() {
      // You can add any custom functionality you need here
      // For example, changing the background color of the option when hovered

       $(".custom-select").toggleClass('active')
   
    });
     $(".custom-options").on("click", function() {
      // Reset the background color when mouse leaves
           $(this).removeClass('active')
  
    });
